// extracted by mini-css-extract-plugin
module.exports = {"baseComponent":"baseContext-module--baseComponent--5mTl_"};